export const SUBTITLE = "Place your order below and your broker will handle the rest.";

export const HELP_TOOLTIP =
  "Your trade has one all-inclusive broker fee covering costs associated with slippage, foreign exchange, and labour involved. A further breakdown will be provided in your invoice.";

export const RESERVED_BALANCE_TOOLTIP =
  "Your reserved balance is the amount locked in for this target order.";

export const SWITCH_TOOLTIP =
  "Selecting this allows you to switch your input for your sell side to your buy side, and vice versa.";

export const STABLE_COIN_CODES = ["BUSD", "DAI", "GUSD", "MUSD", "TUSD", "USDC", "USDT", "USTC"];

export const TRADE_CONFIRMATION_MODAL_MAP = {
  scheduled: "Scheduled_Orders",
  swap: "Swap",
  target: "Target_Orders",
};
